/* eslint-disable */
export class Collapse {
  constructor() {
    this.$collapseBtn = $('.js-collapse');

    // Bind events
    this.$collapseBtn.on('click', e => this.toggle(e));
  }

  toggle(e) {
    const $self = $(e.currentTarget);
    $self.next('div').slideToggle(200);
    $self.toggleClass('open');
  }
}
